// @flow
import styled from 'styled-components';
import { cleanWhite, mercuryGrey } from '../../colors';
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';

export type IconBoxThemeType = {
  Main: StyledComponent<{}, mixed, HTMLDivElement>
    | React$ComponentType<{}>,
  Icon: StyledComponent<{}, mixed, HTMLImageElement>
    | React$ComponentType<{}>,
  Label: StyledComponent<{}, mixed, HTMLHeadingElement>
    | React$ComponentType<{}>,
  Text: StyledComponent<{}, mixed, HTMLDivElement>
    | React$ComponentType<{}>,
}
*/

var IconBoxTheme
/*: IconBoxThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "r1nnft-0"
  })(["display:flex;flex-direction:column;justify-content:center;align-items:center;width:37rem;padding:2rem;border:2px solid ", ";border-radius:8px;background:", ";"], mercuryGrey(), cleanWhite()),
  Icon: styled.img.withConfig({
    displayName: "theme__Icon",
    componentId: "r1nnft-1"
  })(["height:6rem;width:6rem;"]),
  Label: styled.h3.withConfig({
    displayName: "theme__Label",
    componentId: "r1nnft-2"
  })(["margin:2rem 0 0 0;text-align:center;font-size:2rem;font-weight:500;line-height:2.6rem;[dir=rtl] &{font-weight:600;}"]),
  Text: styled.div.withConfig({
    displayName: "theme__Text",
    componentId: "r1nnft-3"
  })(["margin-top:1rem;text-align:center;font-size:2rem;font-weight:200;line-height:2.6rem;"])
};
export default IconBoxTheme;